<template>
	<card type="cinc" class="ReCardClient lightTheme">
		<div class="card-user">
			<div class="mx-auto">
				<!-- <div class="avatarBlk author">
					<div class="photo"><img class="avatar" :src="strPhotoSrc" /></div>
				</div> -->
			</div>
		</div>
		<div class="card-user ">
			<div style="width: 100%;">
				<div>
					<span class="badge badge-pill badge-success" v-if="objClient.client_type == 1">ФИЗ ЛИЦО</span>
					<span class="badge badge-pill badge-primary" v-else>ЮР ЛИЦО</span>
				</div>

				<p class="description row pr-5">
					<span  class="ml-3" v-if="objClient.root_id > 0" >
						<span class="mr-3 text-danger"><i class="tim-icons text-danger icon-alert-circle-exc"></i> Дубликат клиента: </span>
						<router-link :to="'/data/clients/id/'+objClient.root_id" class="d-inline-block">перейти в основного клиента (id:{{objClient.root_id}})</router-link> 
						<p v-if="objClient.root_reasones!='' && objClient.root_reasones!=undefined"> {{ objClient.root_reasones.replace(',,',', ').replace(',','') }} </p>
						<button v-if="isAdmin" class="btn btn-primary btn-simple" @click="unstick(objClient.id)">Расклеить</button>
					</span>
				</p>
				<!-- <p class="description row">
					<span class="d-md-inline-block col-md-4 d-sm-none">ФИО</span> 
					<span class="d-inline-block col-md-7">{{objClient.fio}}</span> 
				</p> -->

				<collapse v-if="objClient.childrens.length > 0" class="client-doubles mb-4 pr-5">
					<collapse-item title="Дубликаты клиента">
						<ul class="list-unstyled result-marker">
							<li v-for="(child, ch_index) in objClient.childrens" :key="ch_index">
								<router-link :to="'/data/clients/id/'+child.id" class="d-inline-block">{{child.name}} (id:{{child.id}})</router-link> 
							</li> 
						</ul>						
					</collapse-item>
				</collapse>

				<div class="row" v-if="masCalls.length>0">
					<div class="d-flex checkbox-radios mb-2">
						<div class="col-12">
							<base-radio v-for="(el_opt, el_index) in masRadio" :key="el_opt.name+'_'+el_index" :name="el_opt.name" v-model="rb_choice" inline>{{el_opt.label}}</base-radio>
						</div>
					</div>
					<ReClientCallList :masCalls="masCalls" class="mb-2 px-3"  v-if="rb_choice == 0" />
					<template v-else v-for="(dopContact, dc_index) in objClient.contacts">
						<p class="ml-1 description row" :key="dc_index" v-if="dopContact.contact_group=='phone'">
							<span class="d-inline-flex col-md-4 align-items-center">{{strContactType(dopContact)}}</span> 
							<a :href="hrefContact(dopContact.contact_group,dopContact.contact_value)" class="d-inline-flex col-md-7 align-items-center" :class="[{'text-primary':dopContact.contact_group=='email'},{'text-success':dopContact.contact_group!='email'}]">
								<i v-if="dopContact.contact_group=='phone'" class="d-inline-block tim-ic ic-phone" @click="Call(dopContact.contact_value,'CLIENT',objClient.id)"></i>
								<span v-if="dopContact.contact_group=='phone'" @click="Call(dopContact.contact_value,'CLIENT',objClient.id)">{{dopContact.contact_value}} </span>
								<span v-else>{{dopContact.contact_value}}</span>
							</a>
						</p>
					</template>
				</div>
				<div class="row align-items-center mx-0">
				<template v-for="(dopContact, dc_index) in objClient.contacts">
					<p class="description row" :key="dc_index" v-if="dopContact.contact_group!='social' && dopContact.contact_group!='phone' && dopContact.contact_group!='messanger'" >
						
						<span v-if="dopContact.contact_group!='messanger'" class="d-inline-flex col-md-4 align-items-center">{{strContactType(dopContact)}}</span> 
						<!--было ниже :href="hrefContact(dopContact.contact_group,dopContact.contact_value)"-->
						
						<a :href="hrefContact(dopContact)" class="d-inline-flex col-md-7 px-0  align-items-center" :class="[{'text-primary':dopContact.contact_group=='email'},{'text-success':dopContact.contact_group!='email'}]">
							<i v-if="dopContact.contact_group=='email'" class="d-inline-flex tim-icons icon-email-85"></i>
							<i v-if="dopContact.contact_group=='phone'" class="d-inline-flex tim-ic ic-phone" @click="Call(dopContact.contact_value,'CLIENT',objClient.id)"></i>
							<i v-if="dopContact.contact_group=='web'" class="d-inline-flex tim-icons icon-link-72"></i>
							<!-- <i v-if="dopContact.contact_group=='messanger'" class="d-inline-flex tim-icons icon-send"></i> -->
							<span v-if="dopContact.contact_group=='phone'" @click="Call(dopContact.contact_value,'CLIENT',objClient.id)">{{dopContact.contact_value}} </span>
							
							<span v-if="dopContact.contact_group!='phone'"
										 style="max-width: 470px;
										overflow: hidden;
										white-space: nowrap;"
							>{{dopContact.contact_value}}</span>
						</a>
						<!-- <a v-if="dopContact.contact_group=='email'" @click="loginMail()" target="_blank" class="d-inline-flex col-md-7 align-items-center text-primary">
							<i v-if="dopContact.contact_group=='email'" class="d-inline-flex tim-icons icon-email-85"></i>
							<span style="max-width: 470px;
										overflow: hidden;
										white-space: nowrap;"
							>{{dopContact.contact_value}}</span>
						</a> -->
						<!-- <ReCopyClipboard v-model="dopContact.contact_value"/> -->
					</p>
					
					<p class="my-2 mr-5 addcontact" v-if="dopContact.contact_group=='phone'">
						<a  class="btn btn-danger btn-simple" :href="'tel:'+dopContact.contact_value.replace(/[.*()-]/g, '')"  target="_blank">Позвонить с мобильного {{ dopContact.contact_value }}</a>
					</p>
				
					<p class="description row" :key="dc_index" v-if="dopContact.contact_group=='phone' && masCalls.length==0">
						<span class="d-inline-flex col-md-4 align-items-center">{{strContactType(dopContact)}}</span> 
						<span class="d-inline-flex  align-items-center">
							<a :href="hrefContact(dopContact.contact_group,dopContact.contact_value)" class="d-inline-flex  align-items-center mr-2" :class="[{'text-primary':dopContact.contact_group=='email'},{'text-success':dopContact.contact_group!='email'}]">
								<i v-if="dopContact.contact_group=='phone'" class="d-inline-block tim-ic ic-phone" @click="Call(dopContact.contact_value,'CLIENT',objClient.id)"></i>
								<span v-if="dopContact.contact_group=='phone'" @click="Call(dopContact.contact_value,'CLIENT',objClient.id)">{{dopContact.contact_value}} </span>
								<span v-else>{{dopContact.contact_value}}</span>
							</a>
							<el-tooltip content="Скопировать" placement="top" >
								<ReCopyClipboard v-model="dopContact.contact_value" v-if="dopContact.contact_group=='phone'"/>
							</el-tooltip>
						</span> 
						<!-- <a class="btn btn-primary btn-simple mx-2" >Добавить в контакты </a> -->
					
						<!-- <a class="btn btn-primary btn-simple mx-2 addcontact" target="__blank" :href="$GVO.endpoint_domen+'/ajaxdata/getvcard.php?phone='+ dopContact.concact_phone_INT" >Добавить в контакты</a> -->
						<a class="btn btn-primary btn-simple ml-3 mt-3 addcontact" target="__blank" :href="$GVO.endpoint_domen+'/ajaxdata/getvcard.php?id='+objClient.id">Добавить в контакты</a>
						
					</p> 

					<p class="description row" :key="dc_index" v-if="dopContact.contact_group=='messanger'">
						<span class="d-inline-flex col-md-4 align-items-center">{{strContactType(dopContact)}}</span> 
						<span class="d-inline-flex col-md-4 align-items-center">
							<a :href="hrefContact(dopContact)" target="_blank" class="d-inline-flex  align-items-center mr-2" :class="[{'text-primary':dopContact.contact_group=='email'},{'text-success':dopContact.contact_group!='email'}]">
								<span>{{dopContact.contact_value}}</span>								
							</a>
						</span> 
						<a class="btn btn-primary btn-simple ml-3 mt-3 addcontact" target="__blank" :href="$GVO.endpoint_domen+'/ajaxdata/getvcard.php?id='+objClient.id">Добавить в контакты</a>
					</p> 
				
				</template>
				<template v-for="(dopContact, dc_index) in objClient.contacts">
					<span class="d-inline-flex mr-2 " style="width: fit-content;" :key="dc_index" v-if="dopContact.contact_group=='social' && dopContact.contact_group!='phone'">
						<!-- <span class="d-inline-block col-md-4">{{strContactType(dopContact)}}</span>  -->
								<!-- <a :href="hrefContact(dopContact.contact_group,dopContact.contact_value)" class="d-inline-block col-md-7" :class="[{'text-success':dopContact.contact_group!='email'}]">
									<span>{{dopContact.contact_value}}</span>
								</a> -->

						<a type="button" target="_blank" :href="dopContact.contact_value" :key="dc_index" v-if="dopContact.contact_type == '32' && dopContact.contact_group=='social'" class="btn btn-icon btn-simple btn-facebook">
							<i class="fab fa-facebook-f"> </i>
						</a>
						<a type="button" target="_blank" :href="dopContact.contact_value" :key="dc_index" v-if="dopContact.contact_type == '36' && dopContact.contact_group=='social'" class="btn btn-icon btn-simple btn-twitter">
							<i class="fab fa-twitter"></i>
						</a>
						<a type="button" target="_blank" :href="dopContact.contact_value" :key="dc_index" v-if="dopContact.contact_type == '31' && dopContact.contact_group=='social'" class="btn btn-icon btn-simple btn-primary">
							<i class="fab fa-vk"></i> 
						</a>
						<a type="button" target="_blank" :href="dopContact.contact_value" :key="dc_index" v-if="dopContact.contact_type == '35' && dopContact.contact_group=='social'" class="btn btn-icon btn-simple btn-warning">
							<i class="fab fa-odnoklassniki"></i>
						</a>
						<a type="button" target="_blank" :href="dopContact.contact_value" :key="dc_index" v-if="dopContact.contact_type == '34' && dopContact.contact_group=='social'" class="btn btn-icon btn-simple btn-primary">
							<i><img class="jj-icon" src="/img/icons/livejournal.svg" alt=""></i>
						</a>
						<a type="button" target="_blank" :href="dopContact.contact_value" :key="dc_index" v-if="dopContact.contact_type == '33' && dopContact.contact_group=='social'" class="btn btn-icon btn-simple btn-google">
							<i class="fab fa-google-plus-g"></i>
						</a>
						<a type="button" target="_blank" :href="dopContact.contact_value" :key="dc_index" v-if="dopContact.contact_type == '37' && dopContact.contact_group=='social'" class="btn btn-icon btn-simple btn-instagram">
							<i class="fab fa-instagram"></i>
						</a>
					</span>

					<span class="d-inline-flex mb-0 " :key="'dop-'+dc_index" v-if="dopContact.contact_group=='messanger'" style="width:fit-content;">
						<el-tooltip :content="dopContact.contact_value" placement="top" >
						<a :href="hrefContact(dopContact)" target="_blank" class="btn btn-icon btn-simple mr-2"
						:class="[{'btn-success':dopContact.contact_type=='41'},{'btn-info':dopContact.contact_type=='42'},{'btn-primary':(dopContact.contact_type!='42' || dopContact.contact_type!='41')}]"
						>
							<i v-if="dopContact.contact_type=='40'" class="d-inline-flex messicon messicon-telegram"></i>
							<i v-if="dopContact.contact_type=='41'" class="d-inline-flex messicon messicon-whatsapp"></i>
							<i v-if="dopContact.contact_type=='42'" class="d-inline-flex messicon messicon-viber"></i>
							<i v-if="dopContact.contact_type=='43'" class="d-inline-flex messicon messicon-skype"></i>
							<!-- <i v-else class="d-inline-flex tim-icons icon-send"></i> -->
						</a>
						</el-tooltip>
					</span>	
				</template>
				</div>
				
				<div class="right_part pt-2">
				<!-- <p class="description row" v-if="objClient.contact_group!='social'">
					<span class="d-inline-flex col-md-7 align-items-center">
						<template v-for="(dopContact, dc_index) in objClient.contacts" >
							
							<span class="d-inline-flex mr-2" style="width: fit-content;" :key="dc_index" v-if="dopContact.contact_group=='social' && dopContact.contact_group!='phone'">
								
								<span class="d-inline-block col-md-4">{{strContactType(dopContact)}}</span> 
								<a :href="hrefContact(dopContact.contact_group,dopContact.contact_value)" class="d-inline-block col-md-7" :class="[{'text-success':dopContact.contact_group!='email'}]">
									<span>{{dopContact.contact_value}}</span>
								</a>

								<a type="button" target="_blank" :href="dopContact.contact_value" :key="dc_index" v-if="dopContact.contact_type == '32' && dopContact.contact_group=='social'" class="btn btn-icon btn-simple btn-facebook">
									<i class="fab fa-facebook-f"> </i>
								</a>
								<a type="button" target="_blank" :href="dopContact.contact_value" :key="dc_index" v-if="dopContact.contact_type == '36' && dopContact.contact_group=='social'" class="btn btn-icon btn-simple btn-twitter">
									<i class="fab fa-twitter"></i>
								</a>
								<a type="button" target="_blank" :href="dopContact.contact_value" :key="dc_index" v-if="dopContact.contact_type == '31' && dopContact.contact_group=='social'" class="btn btn-icon btn-simple btn-primary">
									<i class="fab fa-vk"></i> 
								</a>
								<a type="button" target="_blank" :href="dopContact.contact_value" :key="dc_index" v-if="dopContact.contact_type == '35' && dopContact.contact_group=='social'" class="btn btn-icon btn-simple btn-warning">
									<i class="fab fa-odnoklassniki"></i>
								</a>
								<a type="button" target="_blank" :href="dopContact.contact_value" :key="dc_index" v-if="dopContact.contact_type == '34' && dopContact.contact_group=='social'" class="btn btn-icon btn-simple btn-primary">
									<i><img class="jj-icon" src="/img/icons/livejournal.svg" alt=""></i>
								</a>
								<a type="button" target="_blank" :href="dopContact.contact_value" :key="dc_index" v-if="dopContact.contact_type == '33' && dopContact.contact_group=='social'" class="btn btn-icon btn-simple btn-google">
									<i class="fab fa-google-plus-g"></i>
								</a>
								<a type="button" target="_blank" :href="dopContact.contact_value" :key="dc_index" v-if="dopContact.contact_type == '37' && dopContact.contact_group=='social'" class="btn btn-icon btn-simple btn-instagram">
									<i class="fab fa-instagram"></i>
								</a>
								</a>
							</span>
						</template>
					</span>
				</p> -->
				<p class="description row" v-if="objClient.DateofBirth && objClient.DateofBirth!='0000-00-00 00:00:00'">
					<span class="d-inline-block col-md-4">Дата рождения</span> 
					<span class="d-inline-block col-md-7">{{$GVO.convertDateTimeFromMysqlToDate(objClient.DateofBirth)}}</span> 
				</p>
				<div class="col px-0" v-if="objClient.pasnum!=0">
					<!--p>Паспорт гражданина РФ</p-->
					<p class="description row">
						<span class="d-inline-block col-md-4" v-if="objClient.passport_rf == 1">Паспорт гражданина РФ</span> 
						<span class="d-inline-block col-md-4" v-if="objClient.passport_rf == 0">Паспорт иностранного гражданина</span> 
						<span class="d-inline-block col-md-7"> <span>серия </span> <span class="mr-3">{{objClient.passer}}</span><span>номер </span><span>{{objClient.pasnum}}</span></span> 
						<span class="d-inline-block col-md-4" v-if="objClient.passer_from_client && (isAdmin)"><router-link :to="'/data/clients/id/'+objClient.passer_from_client" class="d-inline-block">ПД с дочернего клиента</router-link></span> 
					</p>
					<p class="description row">
						<span class="d-inline-block col-md-4">Дата выдачи</span> 
						<span class="d-inline-block col-md-7">{{$GVO.convertDateFromMysql(objClient.passport_date)}}</span> 
						<span class="d-inline-block col-md-4" v-if="objClient.passport_date_from_client && (isAdmin)"><router-link :to="'/data/clients/id/'+objClient.passport_date_from_client" class="d-inline-block">ПД с дочернего клиента</router-link></span> 
					</p>
					<p class="description row">
						<span class="d-inline-block col-md-4">Кем выдан</span> 
						<span class="d-inline-block col-md-7">{{objClient.passport_place}}</span> 
						<span class="d-inline-block col-md-4" v-if="objClient.passport_place_from_client && (isAdmin)"><router-link :to="'/data/clients/id/'+objClient.passport_place_from_client" class="d-inline-block">ПД с дочернего клиента</router-link></span> 
					</p>
				</div>	
				<p class="description row" v-if="objClient.inn>0">
					<span class="d-inline-block col-md-4">ИНН</span> 
					<span class="d-inline-block col-md-7">{{objClient.inn}}</span> 
					<span class="d-inline-block col-md-4" v-if="objClient.inn_from_client && (isAdmin)"><router-link :to="'/data/clients/id/'+objClient.inn_from_client" class="d-inline-block">ПД с дочернего клиента</router-link></span> 
				</p>
				<p class="description row" v-if="objClient.snils>0">
					<span class="d-inline-block col-md-4">СНИЛС</span> 
					<span class="d-inline-block col-md-7">{{objClient.snils}}</span> 
					<span class="d-inline-block col-md-4" v-if="objClient.snils_from_client && (isAdmin)"><router-link :to="'/data/clients/id/'+objClient.snils_from_client" class="d-inline-block">ПД с дочернего клиента</router-link></span> 
				</p>
				<template v-if="objClient.address.length>0 && (objClient.address[0].text_addr!='' || objClient.address[0].manual_addr!='')">
					<p class="description row" v-for="objAddr in objClient.address">
						<span class="d-inline-block col-md-4" v-if="objAddr.address_typeId==1">Адрес регистрации</span> 
						<span class="d-inline-block col-md-4" v-if="objAddr.address_typeId==2">Адрес фактический</span> 
						<span class="d-inline-block col-md-7"><span>{{(objAddr.manual_addr!='' && objAddr.text_addr!=objAddr.manual_addr?objAddr.manual_addr:objAddr.text_addr)}}</span><span v-if="objAddr.flat_num!=''">, кв.{{objAddr.flat_num}}</span></span> 
					</p>
				</template>				
				<p class="description row" v-if="objClient.descr!=''">
					<span class="d-inline-block col-md-4">Примечание</span> 
					<span class="d-inline-block col-md-7">{{objClient.descr}}</span> 
				</p>
				
				<collapse>
					<collapse-item title="Фото и Документы">
						<div class="description mb-4" v-if="objClient.pass_files.length>0">
							<p class="d-inline-block col-md-4">Фото паспорта</p> 
							<el-carousel :autoplay="false" arrow="always" height="200px" v-if="objClient.pass_files !='' && typeof objClient.pass_files != 'undefined'">
								<el-carousel-item v-for="pass_img in objClient.pass_files" :key="pass_img.id">
									<a :href="`/DATA/pass/file/${pass_img.filename}`" target="_blank" class="d-block">
										<img :src="`/DATA/pass/file/${pass_img.filename}`" alt="preview">
									</a>
								</el-carousel-item>
							</el-carousel>	
						</div>
						<div class="description mb-4" v-if="objClient.snils_files.length>0">
							<p class="d-inline-block col-md-4">Фото СНИЛС</p> 
							<el-carousel :autoplay="false" arrow="always" height="200px" v-if="objClient.snils_files !='' && typeof objClient.snils_files != 'undefined'">
								<el-carousel-item v-for="snils_img in objClient.snils_files" :key="snils_img.id">
									<a :href="`/DATA/snils/file/${snils_img.filename}`" target="_blank" class="d-block">
										<img :src="`/DATA/snils/file/${snils_img.filename}`" alt=""> 
									</a>
								</el-carousel-item>
							</el-carousel>				
						</div>						
						<div class="description mb-4" v-if="objClient.docs_files.length>0">
							<p class="d-inline-block col-md-4">Другие документы</p> 
							<template v-if="objClient.docs_files !='' && typeof objClient.docs_files != 'undefined'">
								<div class="col" v-for="file in objClient.docs_files" :key="file.filename">
									<a :href="file.link" target="_blank">{{file.filename}}</a>
								</div>
							</template>				
						</div>
					</collapse-item>
				</collapse>
			</div>
			</div>
		</div>
	</card>
</template>

<script>
	import { BaseRadio } from 'src/components/index';
	import ReClientCallList from 'src/our_components/ReClientCallList.vue';
	import { Carousel, CarouselItem, Tooltip } from 'element-ui';	
	import { Collapse, CollapseItem } from 'src/components';
	import ReCopyClipboard from 'src/our_components/ReCopyClipboard.vue';

	

	export default {
		name: 'ReCardClient',
		components: {
			BaseRadio,
			ReClientCallList,
			Collapse,
			CollapseItem,
			[Carousel.name]: Carousel,
			[CarouselItem.name]: CarouselItem,
			[Tooltip.name]: Tooltip,
			ReCopyClipboard,
		},
		props: {
			objClient: Object,
		},
		data () {
			return {
				ver: 1,
				masCalls:[], //client_phone_list
				masRadio:[{name: '0', label: 'Звонок по задаче',}, {name: '1', label: 'Свободный звонок',}],
				rb_choice: 0,
				fields_from_client:[
					'passer_from_client',
					'pasnum_from_client',
					'inn_from_client',
					'passport_rf_from_client',
					'passport_date_from_client',
					'passport_place_from_client',
					'snils_from_client',
					'passport_code_from_client',
				],
			}
		},
		computed: {
			strPhotoSrc(){
				if(this.objClient.photo.indexOf('[') != -1){
					let masPhotos = this.$GVO.SafeParseJson(this.objClient.photo);
					if(masPhotos.length>0){
						return masPhotos[0];
					}
				}
				return this.$GVO.isEmpty(this.objClient.photo)?'/img/placeholder.jpg':this.objClient.photo;
			},
			isAdmin(){
				return (this.$GVO.my_profile.adm == 1)
			},
		},
		methods: {
			/*
			//было раньше
			hrefContact(contactType,contactText){
				console.log(contactType);				
				switch (contactType) {
					case 'email':
						return 'mailto:'+contactText;
						break;
					case 'WhatsApp':
						return 'https://wa.me/'+contactText;
						break;
					case 'telegram':
						return 'tg://resolve?domain='+contactText;
						break;
					case 'viber':
						return 'viber://add?number='+contactText;
						break;
					case 'skype':
						return 'skype:'+contactText+'?call';
						break;
					case 'web':
						return contactText;
						break;
					default:
						return '#';
						break;
				}
				return '#';
			},*/
			hrefContact(dopContact){
				//console.log(contactType);
				let strHref = '#';
				switch (dopContact.contact_type) {
					
					case '11'://email
						strHref = 'mailto:'+dopContact.contact_value;
						break;
					case '41'://watsapp
						strHref = 'whatsapp://send?phone=+'+dopContact.concact_phone_INT;
						break;
					case '40'://telegram
						if(dopContact.concact_phone_INT !=''){
							strHref = 'http://t.me/+'+dopContact.concact_phone_INT;
						}else {strHref = 'http://t.me/'+dopContact.contact_value;}
						// strHref = 'tg://resolve?domain=+'+dopContact.concact_phone_INT;
						// strHref = 'http://t.me/'+dopContact.contact_value;
						// strHref = 't.me/'+dopContact.contact_value;

						break;
					case '42'://viber
						strHref = 'viber://chat?number=+'+dopContact.concact_phone_INT;
						break;
					case '43'://skype
						strHref = 'skype:'+dopContact.contact_value+'?call';
						break;
					case '21'://web
						strHref = dopContact.contact_value;
						break;
				}
				return strHref;
			},
			unstick(client_id){
				this.$GVO.Api.client.UNSTICK_CHILD_CLIENT({flt:{'id': client_id}})
				.then((objApiCat) => { 
					//console.log('UNSTICK_CHILD_CLIENT',objApi);
					if(objApiCat.success === true){
						// location.reload();
						this.$router.push({path: '/data/clients/id/'+client_id+'/edit?client_type='+this.objClient.client_type});
					}
				}).catch(errorObjApi => {console.error(errorObjApi);});
			},
			strContactType: function(objContact){
				if(typeof this.$GVO.cats.CONTACTS_TYPES != 'undefined' && typeof this.$GVO.cats.CONTACTS_TYPES[objContact.contact_group].types != 'undefined'){
					return this.$GVO.cats.CONTACTS_TYPES[objContact.contact_group].types[objContact.contact_type];
				}
				return '';
			},
			Call(strPhone,obj_type,obj_id){
				// console.log('Call',strPhone,obj_type,obj_id);
				this.$GVO.Call(strPhone,obj_type,obj_id);
			},
			getCalls(){
				this.masCalls = [];
				for (let s = 0; s < this.objClient.SERVICES.length; s++) {
					const service = this.objClient.SERVICES[s];
					for (let t = 0; t < service.BP_TASKS.length; t++) {
						const task = service.BP_TASKS[t];
						if(typeof task.BlockType != 'undefined' && task.BlockType=='ClientCall' && typeof task.client_phone_list != 'undefined' && task.client_phone_list != ''){
							this.masCalls.push({'task_id':task.id,'task_name':task.BP_TASK_NAME,'client_phone_list':task.client_phone_list});
						}
					}
				}
			},	
			// callOnMobile(phone){
			// 	// console.log('phone',phone);
			// 	// alert('phone', phone);
			// 	// this.$GVO.showAlert('phone',phone);
			// 	// window.open('tel:'+phone);
			// 	let newphone = phone.replace(/[.*()-]/g, '');
			// 	console.log('phone',newphone);
			// 	window.location.href = 'tel:/' + phone;
			// }	
			
		},
		mounted(){
			this.masCalls = [];
			this.getCalls();
		}
	}
</script>
<style scoped>
	.ReCardClient .badge {font-size: 0.7rem;}
	.ReCardClient .card-user{
		display: flex;
		flex-direction: row;
		justify-content: space-between;		
	}
	.ReCardClient .card-user [slot='header']{
		position: absolute;
		right:0px;
		top:0px;
	}
	.card-user .left_part, .card-user .right_part{
		width: 100%;
		display: flex;
		flex-flow: column nowrap;
	}
	.card-user .left_part{max-width:120px; margin-right: 8px;}
	.card-user .left_part > *, .card-user .right_part > *{display: inline-block; vertical-align: top;}

	.avatarBlk{width:110px;}
	.avatarBlk .avatar{
		object-fit: contain;
		background-color: white;
	}
	.card-user .author{margin-top: 0px; margin-right: 8px;}
	.card-user .avatar {width: 110px; height: 110px;}
	
	.onlineStatus{text-align: center;}
	.onlineStatus > *{display: inline-block;}
	.onlineStatus i{
		width: 7px;
		height: 7px;
		border-radius: 50%;
		margin-right: 5px;
	}
	.onlineStatus.online i{background-color: greenyellow;}
	.onlineStatus.offline i{background-color: red;}

	.socialBlk > *{margin-right: 10px;}

	.fioBlk, .contactsBlk, .orgBlk{margin-top: 35px;}

	.description.row{
		display: flex;
		flex-direction: row;
		margin-bottom: 10px;
	}
	.ReCardClient >>> .description {	width: 100%;}

	p.description a > i{ margin-right: 5px;}
	.title{text-transform: uppercase;}

	.btn-icon .fab{
		position: absolute;
		font-size: 1em;
		top: 50%;
		left: 50%;
		-webkit-transform: translate(-12px, -12px);
		transform: translate(-12px, -12px);
		line-height: 1.5626rem;
		width: 24px;
	}
	.addcontact{display: none;}	
	/* [href^="tel:"]:after{content:attr(href);} */

	@media (max-width: 600px){
		.ReCardClient .card-user{
			display: block;
		}
		.card-user .left_part, .card-user .right_part{display: block;}	
		/* .addcontact{display: inline-block;}		 */
	}
	@media (max-width: 768px){
		.addcontact{display: inline-block;}		
		.ReCardClient >>> .description > * {	width: 100%;}
		.ReCardClient >>> .description a.addcontact{	width: calc(100% - 48px);}
		.ReCardClient >>> .description > a , .ReCardClient >>> .description > span > a{margin-left: 15px;}
	}
	@media (max-width: 1200px){
		.ReCardClient .card-user {flex-direction: column;}
		.ReCardClient .left_part {margin: 0 auto;}
		
	}

	.jj-icon {
		height: 18px;
		width: 18px;
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-9px, -9px);
	}
	.white-content .card:not(.card-white) .lightTheme {background: #f1f6fc!important; box-shadow: 0px 3px 10px 0px rgba(123, 123, 123, 0.25)!important; border: 1px solid #9e77f3;}
	.ReCardClient {border: 1px solid #9e77f3;}

	.ReCardClient .card-collapse{
		border-right: none!important;
		height: fit-content;
		display: inline-block;
		width: 100%!important;
		padding: 0px;
	}
	.ReCardClient >>> .card-collapse .card:not(.card-cinc) .card-header a {color: #01B0E0;}
	.ReCardClient >>> .card-header {padding-bottom: 0px!important; padding-top: 0px!important;}
	.ReCardClient >>> .card-user .card-body {min-height: auto!important;}

	.ReCardClient >>> .messicon {
		width: 18px;
		height: 18px;
		display: inline-block;
		margin-top: 8px;
	}
	.ReCardClient >>> .messicon-telegram {background: url('/img/icons/telegramlogo.svg') no-repeat; }
	.ReCardClient >>> .messicon-whatsapp {background: url('/img/icons/whatsapplogo.svg') no-repeat; }
	.ReCardClient >>> .messicon-viber {background: url('/img/icons/viberlogo.svg') no-repeat; }
	.ReCardClient >>> .messicon-skype {background: url('/img/icons/skypelogo.svg') no-repeat; }

	
</style>
